import { initializePricingContext, isPricingContextInitialized, getPricingContext, getPricingContextVatInclusivity } from './src-utils-pricingContext.util.js';
import pricingContextModuleHelpers from '@vp/pricing-context-module/helpers';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';
import { useEffect } from 'react';

const usePricingContext = (tenant, market, developmentMode) => {
  const setPricingContext = useCouponDetailsStore((state) => state.setPricingContext);
  const setVatIncl = useCouponDetailsStore((state) => state.setVatIncl);
  useEffect(() => {
    const updatePricingContextData = () => {
      setPricingContext(getPricingContext());
      setVatIncl(getPricingContextVatInclusivity());
    };
    const handleInitializedEvent = () => {
      const initialized = isPricingContextInitialized();
      if (initialized) {
        updatePricingContextData();
      }
    };
    const updatePricingContext = () => {
      setPricingContext(getPricingContext());
    };
    const updateVatInclusivity = () => {
      setVatIncl(getPricingContextVatInclusivity());
    };
    if (developmentMode) {
      initializePricingContext(tenant, market, handleInitializedEvent);
    } else if (!isPricingContextInitialized()) {
      document.addEventListener(
        pricingContextModuleHelpers.EVENTS.INITIALIZED_EVENT,
        handleInitializedEvent
      );
    } else {
      updatePricingContextData();
    }
    document.addEventListener(
      pricingContextModuleHelpers.EVENTS.VAT_INCLUSIVITY_CHANGE_EVENT,
      updateVatInclusivity
    );
    document.addEventListener(
      pricingContextModuleHelpers.EVENTS.CONTEXT_CHANGE_EVENT,
      updatePricingContext
    );
    return () => {
      if (!isPricingContextInitialized()) {
        document.removeEventListener(
          pricingContextModuleHelpers.EVENTS.INITIALIZED_EVENT,
          handleInitializedEvent
        );
      }
      document.removeEventListener(
        pricingContextModuleHelpers.EVENTS.VAT_INCLUSIVITY_CHANGE_EVENT,
        updateVatInclusivity
      );
      document.removeEventListener(
        pricingContextModuleHelpers.EVENTS.CONTEXT_CHANGE_EVENT,
        updatePricingContext
      );
    };
  }, [tenant, market, setPricingContext, setVatIncl, developmentMode]);
};

export { usePricingContext };
//# sourceMappingURL=src-hooks-usePricingContextInitialization.js.map
